import svg4everybody from "svg4everybody";
import $ from "jquery";
import Ajax from "base/Ajax";
import LocationModal from "./LocationModal";
import FormValidator from "base/FormValidator";
import Modal from "./Modal";
import moment from "moment";
import PageAnimations from "webPage/PageAnimations";
import GlobalEvents from "base/GlobalEvents";
import VideoHelper from "video/VideoHelper";

$(function () {
    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    PageAnimations.start();

    $('body').on('click', '.js-modal-button', function () {
        $('body').addClass('show-modal');
        let id = $(this).attr('data-id');
        $('.modal[data-id="' + id + '"]').addClass('modal--active');
        return false;
    }).on('click', '.js-close-modal', function (e) {
        if (!$(e.target).is('.js-close-modal')) return;
        $('body').removeClass('show-modal');
        $('.modal').removeClass('modal--active');
        return false;
    }).on('click', '.js-location-button', function () {
        let id = $(this).attr('data-location');
        let color = $(this).attr('data-color');
        let name = $(this).attr('data-location-name');
        LocationModal.show_modal(id, color, name);
        return false;
    }).on("click", ".modal__container", (e) => {
        console.log(e);
        e.stopPropagation();
    }).on("click", ".modal", () => {
        GlobalEvents.emit('website.modal.close');
        $("body").removeClass("modal-active");
        $(".modal--active").removeClass("modal--active");
    }).on('click', '.js-watch-video', function () {
        let $modal = $("<div>").addClass("modal modal--video");
        let $modalContent = $("<div>").addClass("modal__container modal__container--video");
        let $closeButton = $("<button>").addClass("modal__close-btn");

        $modal.append([$closeButton, $modalContent]);

        let $caseStudy = $(this);

        let $video = eotwJSXFactory('div');

        let $wrap = eotwJSXFactory('div', {class: "video__wrapper video__wrapper--loading"}, [$video]);
        $modalContent.html($wrap);
        $("body").append($modal);

        let player = VideoHelper.process($caseStudy.attr("data-provider"), $caseStudy.attr("data-video-id"), $video, {autoplay: true});

        player.on("loaded", () => {
            $wrap.addClass("video__wrapper--playing");
        });

        let fn = () => {
            $modal.remove();
            player.destroy();
        };

        GlobalEvents.on('website.modal.close', fn, true);

        $("body").addClass("modal-active");
        $modal.addClass("modal--active");

        return false;
    }).on('click', '.js-cancellations', () => {
        let modal = new Modal({
            "title": "Cancellation Information",
            "color": 'contact',
            "destroyOnClose": true
        });

        let cancellationInformation = JSON.parse($('.js-cancellation-information').text());

        let $content = $('<div>').addClass('modal__contact modal__contact--cancellations').html(cancellationInformation.activeRevision.values['cancellation-text']);

        modal.setContent($content);
        modal.show();

        return false;
    });

    let formInvalid = false;

    FormValidator.attach($(".js-contact")).on("input:invalid", function (data) {
        data.input.$input.parents('.form__row').addClass('form__row--error');
    }).on("input:valid", function (data) {
        data.input.$input.parents('.form__row').removeClass('form__row--error');
    }).on("invalid", function ($form) {
        if (!formInvalid) {
            formInvalid = true;
            return;
        }
        let $btn = $form.find("button[type='submit']");
        $btn.addClass("btn--loading");
        $form.find('.form__row--error').removeClass('form__row--error');
        setTimeout(() => {
            $.each(this.inputs, function (_, input) {
                input.validate();
            });
            $btn.removeClass('btn--loading');
        }, 600);
    }).on("submit", function ($form) {
        let $btn = $form.find("button[type='submit']");
        if ($btn.is(".btn--loading")) return;
        $btn.addClass("btn--loading");

        Ajax.post("contact", "", {
            name: $form.find(".js-name").val(),
            email: $form.find(".js-email").val(),
            phone: $form.find(".js-phone").val(),
            message: $form.find(".js-message").val(),
        }, Ajax.WEBSITE).then((data) => {
            $btn.removeClass("btn--loading");

            $form.find(".js-name").val('');
            $form.find(".js-email").val('');
            $form.find(".js-phone").val('');
            $form.find(".js-message").val('');

            let modal = new Modal({
                "title": "Thanks for your message",
                "color": 'contact',
                "destroyOnClose": true
            });

            let $content = (
                eotwJSXFactory('div', {class: "modal__contact"}, [
                    eotwJSXFactory('p', null, ["We’ll get back to you soon regarding your message but in the meantime stay groovy!"]),
                    eotwJSXFactory('p', null, ["If you need anything else you can contact us on"]),
                    eotwJSXFactory('a', {href: "mailto:info@sk8hire.co.uk", class: "modal__footer-email modal__footer-email--contact"}, ["info@sk8hire.co.uk"]),
                    eotwJSXFactory('br'),
                    eotwJSXFactory('span', {class: "modal__footer-numbers modal__footer-numbers--contact"}, [eotwJSXFactory('a', {href: "tel:078114600111"}, ["07811 460 0111"]),eotwJSXFactory('a', {href: "tel:01926293650"}, ["01926 293 650"])])
                ]));

            modal.setContent($content);
            modal.show();


        }).catch(e => {
            $btn.removeClass("btn--loading");
            alert(e);
        });
    });

    let $bookingResult = $('.js-booking-result');

    if ($bookingResult.length === 1) {
        let bookingData = JSON.parse($bookingResult.text());

        let title = '';
        let $content = '';

        if (bookingData.confirmed === 1 || bookingData.confirmed === true) {
            title = 'Thanks for booking';

            let date = moment.unix(bookingData.event.eventDate.timestamp).format('ddd Do MMMM YYYY');
            let adult_tickets = 0;
            let child_tickets = 0;
            let child_skates = '';
            let adult_skates = '';
            let ticket_text = '';
            let $skate_text;
            let skates = false;
            let location = bookingData.event.location.name + ', ' + bookingData.event.location.address;

            bookingData.tickets.map(function (ticket) {
                if (ticket.ticketType.name === "Adult") {
                    adult_tickets++;
                } else if (ticket.ticketType.name === "Child") {
                    child_tickets++;
                }

                if (ticket.skateSize !== null) {
                    skates = true;
                    if (ticket.ticketType.name === "Adult") {
                        adult_skates += ticket.skateSize.name + ', ';
                    } else if (ticket.ticketType.name === "Child") {
                        child_skates += ticket.skateSize.name + ', ';
                    }
                }
            });

            if (child_tickets > 0) {
                if (child_tickets === 1) {
                    ticket_text += child_tickets + ' Child';
                } else {
                    ticket_text += child_tickets + ' Children';
                }
                if (adult_tickets > 0) {
                    ticket_text += ', ';
                }
            }

            if (adult_tickets > 0) {
                if (child_tickets === 1) {
                    ticket_text += adult_tickets + ' Adult';
                } else {
                    ticket_text += adult_tickets + ' Adults';
                }
            }

            child_skates = child_skates.substring(0, child_skates.length - 2);
            adult_skates = adult_skates.substring(0, adult_skates.length - 2);

            ticket_text = ticket_text === '' ? 'No tickets booked' : ticket_text;
            child_skates = child_skates === '' ? 'No child skates required' : child_skates;
            adult_skates = adult_skates === '' ? 'No adult skates required' : adult_skates;

            if (skates) {
                $skate_text = (
                    eotwJSXFactory('div', null, [
                        eotwJSXFactory('h5', null, ["Skate Sizes Required"]),
                        eotwJSXFactory('h6', null, ["Children skates"]),
                        eotwJSXFactory('p', null, [child_skates]),
                        eotwJSXFactory('h6', null, ["Adult skates"]),
                        eotwJSXFactory('p', null, [adult_skates])
                    ])
                );
            }

            $content = (
                eotwJSXFactory('div', {class: "modal__success"}, [
                    eotwJSXFactory('h4', null, ["We'll see you on"]),
                    eotwJSXFactory('h3', null, [date, " ", eotwJSXFactory('br')," at ", location]),
                    eotwJSXFactory('h5', null, ["Tickets"]),
                    eotwJSXFactory('p', null, [ticket_text]),
                    $skate_text
                ])
            );
        } else {
            title = 'Booking Not Processed';
            $content = (
                eotwJSXFactory('div', {class: "modal__success"}, [
                    eotwJSXFactory('h3', null, ["There was an error processing your booking."]),
                    eotwJSXFactory('p', null, ["Something went wrong while trying to process your booking, please try again."])
                ])
            );
        }

        let modal = new Modal({
            "title": title,
            "color": bookingData.color,
            "destroyOnClose": true
        });

        modal.setContent($content);
        modal.show();
    }


    let modal = new Modal({
        "title": "Thanks for your message",
        "color": 'contact',
        "destroyOnClose": true
    });

});
